// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { sparseCustomerSchema } from '@/sparse/api/types';
import { dateTimeSchema } from '@/utilities/date-time-schema';
import { z } from 'zod';

export type CustomerTriageStatus =
  | 'all'
  | 'NEEDS_REVIEW'
  | 'MATCHED'
  | 'DISMISSED';

const customerBillingContactSchema = z.object({
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  billingAddress: z.string().nullable(),
});

export const customerTriageSchema = z.object({
  id: z.string(),
  key: z.string(),
  displayName: z.string(),
  companyName: z.string().nullable(),
  email: z.string().nullable(),
  domain: z.string().nullable(),
  webUrl: z.string().nullable(),
  phone: z.string().nullable(),
  billingAddress: z.string().nullable(),
  createdAt: dateTimeSchema,
  triagedAt: dateTimeSchema.nullable(),
  isTriaged: z.boolean(),
  isDismissed: z.boolean(),
  dismissedAt: dateTimeSchema.nullable(),
  status: z.enum(['NEEDS_REVIEW', 'MATCHED', 'DISMISSED']),
  customer: sparseCustomerSchema.nullable(),
  billingContact: customerBillingContactSchema.nullable(),
});

export type CustomerTriage = z.infer<typeof customerTriageSchema>;

export interface CustomerTriageFilter {
  status?: CustomerTriageStatus;
  page?: number;
  limit?: number;
}

const customerTriageCountsSchema = z.object({
  needsReview: z.number(),
  matched: z.number(),
});

export type CustomerTriageCounts = z.infer<typeof customerTriageCountsSchema>;

export const customerTriageCountsResponseSchema = z.object({
  data: customerTriageCountsSchema,
});
